
import { ArrowRight } from "lucide-react";
import { Button, ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { HeroBackground } from "@/components/ui/hero-background";

export const HeroSection = () => {
  return (
    <HeroBackground 
      pattern="circuit" 
      colorScheme="purple" 
      height="h-[600px] md:h-[700px]"
      className="animate-fade-in"
    >
      {/* Content container */}
      <Container className="py-12">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-purple-100 text-purple-800 rounded-full text-sm font-medium mb-5 animate-fade-up">
            Strategic Microsoft 365 Platform Engineering
          </span>
          
          <h1 id="hero-heading" className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight tracking-tight text-gray-900 animate-fade-up">
            Transform Microsoft 365 into Your{" "}
            <span className="bg-gradient-to-r from-edgefi-purple to-edgefi-amethyst bg-clip-text text-transparent">
              Strategic Business Platform
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-light animate-fade-up" style={{ animationDelay: "0.1s" }}>
            Move beyond basic deployment. Our enterprise-grade engineering creates a scalable, secure, and automated Microsoft 365 environment that drives measurable business outcomes.
          </p>
          
          {/* Key differentiators */}
          <div className="flex flex-wrap justify-center gap-4 mb-8 animate-fade-up" style={{ animationDelay: "0.15s" }}>
            <span className="bg-white/80 px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 border border-gray-200">
              Tenant Architecture
            </span>
            <span className="bg-white/80 px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 border border-gray-200">
              Security Design
            </span>
            <span className="bg-white/80 px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 border border-gray-200">
              Custom Automation
            </span>
            <span className="bg-white/80 px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 border border-gray-200">
              Integration Framework
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <ContactButton
              className="bg-edgefi-purple hover:bg-edgefi-purple/90 text-white group"
              modalTitle="Microsoft 365 Engineering Consultation"
              modalDescription="Tell us about your Microsoft 365 engineering and architecture goals."
              variant="cta"
              size="lg"
            >
              Schedule a Consultation
              <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </ContactButton>
            <Button 
              variant="outline" 
              size="lg" 
              className="border-edgefi-purple/20 hover:border-edgefi-purple/40"
              onClick={() => {
                const servicesSection = document.getElementById('services');
                if (servicesSection) {
                  servicesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              View Our Services
            </Button>
          </div>
        </div>
      </Container>
    </HeroBackground>
  );
};
